import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Menu.css";
import { gsap } from "gsap";

function Menu() {
  useEffect(() => {
    gsap.to(".menu-wrap", {
      y: -150,
      duration: 0.9, // seconds
      ease: "power3.InOut",
    });
  }, []);

  return (
    <div className="menu-wrap">
      <div className="menu-inner">
        <ul>
          <li>
            <NavLink to="/">Home</NavLink>
          </li>
          <li>
            <NavLink to="/about">About</NavLink>
          </li>
          <li>
            <NavLink to="/Services">Services</NavLink>
          </li>
          <li>
            <NavLink to="/contact">Contact</NavLink>
          </li>
          <li>
            <NavLink to="https://blog.techfreelancex.com/">Blog</NavLink>
          </li>

          <div className="white-block"></div>
        </ul>
      </div>
    </div>
  );
}

export default Menu;
